export default {"src":"/_next/static/media/icon-blog.3e6432f3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};